var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liveFeedContainer"},_vm._l((_vm.cameraUrls),function(cam){return _c('cameraFeed',{key:cam,attrs:{"cameraUrl":cam}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }